import { observable } from 'mobx';
import type { OrganizationArgs } from '../organization/organization2';

export type UserResponseArgs = {
  id: number;
  name: string;
  first_name?: string;
  last_name?: string;
  department_id?: number;
  organization?: OrganizationArgs;
};

export type UserArgs = {
  id: number;
  name: string;
  first_name?: string;
  last_name?: string;
  department_id?: number;
  organization?: OrganizationArgs;
};

export const convertUserResponseToArgs = (response: UserResponseArgs) => {
  const args: UserArgs = {
    id: response.id,
    name: response.name,
    first_name: response.first_name,
    last_name: response.last_name,
    department_id: response.department_id,
    organization: response.organization
  };
  return args;
};

export default class User {
  @observable id: number;
  @observable name: string;
  @observable first_name?: string;
  @observable last_name?: string;
  @observable department_id?: number;
  @observable organization?: OrganizationArgs;

  constructor(args: UserArgs) {
    this.id = args.id;
    this.name = args.name;
    this.first_name = args.first_name;
    this.last_name = args.last_name;
    this.department_id = args.department_id;
    this.organization = args.organization;
  }
}
